import * as types from '../types'

export default function () {
  return {
    type: types.REMOVE_EMAIL,
  }
}
